<template>
  <div class="wrapper">
    <dash-header></dash-header>
    <sidebar></sidebar>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 title">Dashboard</h1>
            </div>
            <!-- /.col -->
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link to="/dash">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
            <!-- /.col -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </section>
      <!-- /.content-header -->

      <section class="content dash">
        <div class="container-fluid">
          <div class="row">

            <div class="col-lg-12">
                <div class="alert alert-danger mb-2" v-if="!isProfileVerified">
                    Your account has not been verified by the admin, please wait until the verification process is complete.
                </div>

                <div class="alert alert-warning" v-if="this.configure.length > 0 && this.configure[0].admission_status=='PENDING'">
                    Thank you for applying as an agent. Please wait for verification from the admin regarding the status of your registration.
                </div>
            </div>

            <div class="col-lg-12 connectedSortable">
              <!-- My Fiends -->
              <div class="card card_friends">
                <div class="card-header">
                  <h3 class="card-title">My Referral</h3>

                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body p-0">
                  <b-table id="my-table" :items="myreferral" :per-page="perPage" :current-page="currentPage" hover
                    :fields="fields">
                    <template #cell(investor_name)="data">
                      <span class="">
                        <img width="40" height="40" src="../assets/image/default_profile.svg" alt="" />
                        {{ data.item.name }}
                      </span>
                    </template>
                    <template #cell(total_deposit)="data">
                      <span class="badge badge-success">${{ data.item.total_deposit }}</span>
                    </template>
                    <!-- <template #cell(product_type)="data">
                                            <span class="fs-6" v-if="data.item.product_type =='FUND_MANAGER'">FUND MANAGER</span>
                                            <span class="fs-6" v-else>{{ data.item.product_type ? data.item.product_type : '-' }}</span>
                                        </template> -->
                  </b-table>
                  <p class="text-center" v-if="myreferral.length == 0">
                    Data not available.
                  </p>

                  <div class="m-3">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
                    </b-pagination>
                  </div>
                  <!-- <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Deposit</th>
                                                    <th>Product Type</th>
                                                    <th>Broker</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="myreferral.length == 0">
                                                    <td colspan="4" class="text-center">Data not available.</td>
                                                </tr>
                                                <tr v-for="ref in myreferral" :key="ref.id">
                                                    <td class="align-middle">
                                                        <div class="d-flex align-items-center name_col">
                                                            <figure class="friends_img">
                                                                <img src="../assets/image/default_profile.svg" alt="">
                                                            </figure>
                                                            <p>{{ref.investor_name ? ref.investor_name : '-'}}</p>
                                                        </div>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span class="badge badge-success">${{ref.deposit_amount ? ref.deposit_amount : ''}}</span>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span v-if="ref.product_type == 'FUND_MANAGER'">FUND MANAGER</span>
                                                        <span v-else>{{ref.product_type ? ref.product_type : '-'}}</span>
                                                    </td>
                                                    <td class="align-middle">{{ref.broker_name ? ref.broker_name : '-'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->
                </div>
              </div>
              <!--/.direct-chat -->
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 connectedSortable">
              <div class="d-flex justify-content-between mt-3">
                <h5 class="title mt-3">My Subscriptions</h5>
                <router-link to="/subscriptions" class="text-danger fw-bold text-decoration-none">
                  View All
                </router-link>
              </div>

              <h5 class="text-mude" v-if="pendingorder.length < 1 && subscriptions.length < 1 && !loading">
                No Subscriptions Available.
              </h5>

              <swiper ref="subsSwiper" :options="swiperOptions" v-else>
                <swiper-slide v-for="(pend, index) in pendingorder" :key="'p' + pend.id + index">
                  <div class="card card_robot">
                    <div class="card-body">
                      <figure class="robot_img">
                        <img :src="pend.product_image" alt="" />
                      </figure>
                      <div class="text">
                        <h6 class="name">{{ pend.product_name }}</h6>

                        <div class="row">
                          <div class="col-6">
                            <p class="info">Status</p>
                            <p class="info_text">
                              <span class="badge badge-success" v-if="pend.status == 'SUCCESS'">{{ pend.status }}</span>
                              <span class="badge badge-warning" v-else>{{
                                pend.status
                              }}</span>
                              <!-- <span class="badge badge-warning" v-if="pend.status == 'PENDING'">{{pend.status}}</span>
                                                            <span class="badge badge-success" v-else-if="pend.status == 'INSTALLED'">{{pend.status}}</span>
                                                            <span class="badge badge-danger" v-else>{{pend.status ? pend.status : '-'}}</span> -->
                              <!-- <span class="badge badge-warning" v-else-if="product.risk_level == 'MEDIUM'">{{product.risk_level}}</span>
                                                            <span class="badge badge-success" v-else>{{product.risk_level ? product.risk_level : '-'}}</span> -->
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="info">Product Type</p>
                            <p class="info_text type_text" v-if="pend.product_type == 'FUND_MANAGER'">
                              FUND MANAGER
                            </p>
                            <p class="info_text type_text" v-else>
                              {{ pend.product_type }}
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="info">Broker</p>
                            <p class="info_text">
                              {{ pend.broker_name ? pend.broker_name : "-" }}
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="info">Risk Level</p>
                            <p class="info_text">
                              <span class="badge badge-danger" v-if="pend.risk_level == 3">HIGH</span>
                              <span class="badge badge-warning" v-else-if="pend.risk_level == 2">MEDIUM</span>
                              <span class="badge badge-success" v-else>LOW</span>
                            </p>
                          </div>
                          <div class="col-12">
                            <template v-if="pend.broker_account_id !== null">
                              <p class="info">Transaction Code :</p>
                              <h3 class="info_text type_text">
                                {{ pend.transaction_code }}
                              </h3>
                              <p class="info">Transaction Date :</p>
                              <h3 class="info_text type_text">
                                {{ formatDate(pend.created_at) }}
                              </h3>
                            </template>
                            <p class="info">Payment Amount</p>
                            <h3 class="price" v-if="pend.payment_amount.length >= 13">
                              Rp {{ pend.payment_amount.subString(0, 13) + "..." }}
                            </h3>
                            <h3 class="price" v-else>
                              Rp {{ formatPrice(pend.payment_amount) }}
                            </h3>
                            <!-- <p class="desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum, doloremque.</p> -->
                          </div>
                          <!-- <div class="col-12">
                                                        <p class="info">Product Type</p>
                                                        <p class="" v-if="pend.product_type == 'FUND_MANAGER'">FUND MANAGER</p>
                                                        <p class="" v-else>{{pend.product_type}}</p>
                                                    </div> -->
                        </div>
                      </div>
                      <div class="button">
                        <div v-if="pend.broker_account_id == null" @click="sendIdTrans(pend)">
                          <router-link :to="'robot/' + pend.product_id + '/broker/'" v-if="pend.product_type == 'ROBOT'"
                            class="btn btn_outline_red btn-block">Select Broker</router-link>
                          <router-link :to="'fund-manager/' + pend.product_id + '/broker/'" v-else
                            class="btn btn_outline_red btn-block">Select Broker</router-link>
                        </div>
                        <router-link :to="'/payment/' + pend.id" v-else-if="
                          pend.payment_amount !== 0 &&
                          pend.activation_code == null &&
                          pend.status !== 'SUCCESS' && pend.status !== 'CANCELED'
                        " class="btn btn_grey btn-block">Waiting Payment Verification</router-link>
                        <button v-else-if="pend.status === 'CANCELED' && pend.payment_url !== null"
                          class="btn btn_grey btn-block">
                          Payment Expired
                        </button>
                        <button v-else-if="pend.status === 'CANCELED' && pend.payment_url == null"
                          class="btn btn_grey btn-block">
                          Cancel by System
                        </button>
                        <router-link :to="'/activation/' + pend.id" v-else-if="pend.product_type == 'FUND_MANAGER'"
                          class="btn btn_red btn-block">Continue Activation</router-link>
                        <!-- <button type="button" v-else-if="pend.status == 'SUCCESS' && pend.product_type == 'ROBOT'" class="btn btn_red btn-block" @click="handleRobot(pend)" data-toggle="modal" data-target="#activateRobot">Activate Robot</button> -->
                        <router-link :to="'/activation/robot/' + pend.id" v-else-if="
                          pend.status == 'SUCCESS' && pend.product_type == 'ROBOT'
                        " class="btn btn_red btn-block">Activate Robot</router-link>
                        <router-link :to="'/payment/' + pend.id" v-else class="btn btn_red btn-block">Complete
                          Payment</router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide v-for="(item, index) in subscriptions" :key="'s' + item.id + index">
                  <div class="card card_robot">
                    <div class="card-body">
                      <figure class="robot_img">
                        <img :src="item.product_image" alt="" />
                      </figure>
                      <div class="text">
                        <h6 class="name">{{ item.product_name }}</h6>

                        <div class="row">
                          <div class="col-6">
                            <p class="info">Status</p>
                            <p class="info_text">
                              <span class="badge badge-warning" v-if="item.installation_status == 'PENDING'">{{
                                item.installation_status }}</span>
                              <span class="badge badge-success" v-else-if="item.installation_status == 'INSTALLED'">{{
                                item.installation_status }}</span>
                              <span class="badge badge-danger" v-else>{{
                                item.installation_status ? item.installation_status : "-"
                              }}</span>
                              <!-- <span class="badge badge-warning" v-else-if="product.risk_level == 'MEDIUM'">{{product.risk_level}}</span>
                                                            <span class="badge badge-success" v-else>{{product.risk_level ? product.risk_level : '-'}}</span> -->
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="info">Product Type</p>
                            <p class="info_text type_text" v-if="item.product_type == 'FUND_MANAGER'">
                              FUND MANAGER
                            </p>
                            <p class="info_text type_text" v-else>
                              {{ item.product_type }}
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="info">Broker</p>
                            <p class="info_text">
                              {{ item.broker_name }}
                            </p>
                          </div>
                          <!-- <div class="col-6">
                                                        <p class="info">Risk Level</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-danger" v-if="item.risk_level == 3">HIGH</span>
                                                            <span class="badge badge-warning" v-else-if="item.risk_level == 2">MEDIUM</span>
                                                            <span class="badge badge-success" v-else>LOW</span>
                                                        </p>
                                                    </div> -->
                          <div class="col-12">
                            <p class="info">Transaction Code :</p>
                            <h3 class="info_text type_text mb-4">
                              {{ item.transaction_code }}
                            </h3>
                            <p class="info">Transaction Date :</p>
                            <h3 class="info_text type_text mb-3">
                              {{ formatDate(item.created_at) }}
                            </h3>
                          </div>
                          <!-- <div class="col-12">
                                                        <p class="info">Product Type</p>
                                                        <p class="" v-if="item.product_type == 'FUND_MANAGER'">FUND MANAGER</p>
                                                        <p class="" v-else>{{item.product_type}}</p>
                                                    </div> -->
                        </div>
                      </div>
                      <div class="button" style="margin-top: 30px">
                        <!-- <router-link :to="'/product/'+product.id" class="btn btn_red btn-block">View Detail</router-link> -->
                        <router-link :to="'/payment' + item.id" v-if="item.installation_status == 'Expired'"
                          class="btn btn_red btn-block">Renew</router-link>
                        <!-- <button type="button" v-else-if="item.installation_status == 'PENDING'" class="btn btn_red btn-block" @click="handleRobot(item)" data-toggle="modal" data-target="#activateRobot">Activate Robot</button> -->
                        <button class="btn btn_grey btn-block" v-else disabled>
                          Paid
                        </button>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>

              <div class="modal fade" id="activateRobot" data-backdrop="static" data-keyboard="false" tabindex="-1"
                aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-body">
                      <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button> -->
                      <div class="text-center">
                        <h3 class="title">Activate Robot "{{ RobotName }}"</h3>
                        <p>Please enter the Code to activate this robot!</p>
                      </div>

                      <form @submit.prevent="">
                        <div class="mx-4">
                          <input type="text" placeholder="Enter a code.." class="form-control" />
                        </div>
                        <!-- <input type="hidden" v-model="product.investor_id" class="form-control" readonly > -->
                        <!-- <input type="hidden" v-model="product.broker_account_id" class="form-control" readonly >
                                                <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                <input type="hidden" v-model="product.payment_amount" class="form-control" readonly >
                                                <input type="hidden" v-model="product.currency" class="form-control" readonly >
                                                <input type="hidden" v-model="product.status" class="form-control" readonly > -->
                        <div class="row">
                          <div class="col-lg-6 mx-auto">
                            <div class="text-center button d-flex align-items-center justify-content-center">
                              <button type="button" class="btn btn_grey m-2" data-dismiss="modal">
                                Cancel
                              </button>
                              <button type="submit" class="btn btn_red">Activate</button>
                              <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                              <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="loading">
                <div class="col-lg-4" v-for="index in 3" :key="index">
                  <div class="card">
                    <div class="card-body">
                      <ContentLoader />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Available Robot -->
          <div class="row">
            <div class="col-lg-12 connectedSortable">
              <div class="d-flex justify-content-between mt-3">
                <h5 class="title">Available Robot</h5>
                <router-link to="/my-products/robots" class="text-danger fw-bold text-decoration-none">
                  View All
                </router-link>
              </div>

              <h5 class="text-mude" v-if="robots.length < 1 && !loading">
                Robot Not Available.
              </h5>

              <swiper ref="robotSwiper" :options="swiperOptions" v-else>
                <swiper-slide v-for="(robot, index) in robotsActive" :key="index">
                  <div class="card card_robot">
                    <div class="card-body">
                      <figure class="robot_img">
                        <img :src="robot.image" alt="" />
                      </figure>
                      <div class="text">
                        <h6 class="name">{{ robot.name }}</h6>

                        <div class="row">
                          <div class="col-md-6 col-sm-12">
                            <p class="info">Risk Level</p>
                            <p class="info_text">
                              <span class="badge badge-danger" v-if="robot.risk_level == 3">HIGH</span>
                              <span class="badge badge-warning" v-else-if="robot.risk_level == 2">MEDIUM</span>
                              <span class="badge badge-success" v-else>LOW</span>
                            </p>
                          </div>
                          <div class="col-12 data-strategy">
                            <p class="info">Strategy</p>
                            <div class="d-block align-items-center justify-content-between d-lg-flex">
                              <p class="desc" v-if="robot.strategy.length >= 30"
                                v-html="robot.strategy.substring(0, 30) + '...'">
                              </p>
                              <p class="desc" v-else v-html="robot.strategy ? robot.strategy : '-'"></p>
                              <!-- Button trigger modal -->
                              <button type="button" class="btn read_btn btn-sm" v-if="robot.strategy.length >= 30"
                                @click="viewMore(robot)" data-toggle="modal" data-target="#staticBackdrop">
                                Read More
                              </button>
                            </div>
                            <!-- <p class="desc" v-html="robot.strategy ? robot.strategy : '-'"></p> -->
                          </div>
                        </div>
                      </div>
                      <div class="button">
                        <router-link :to="'/robot/' + robot.id" class="btn btn_red btn-block">View Detail</router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>

              <div class="row" v-if="loading">
                <div class="col-lg-4" v-for="index in 3" :key="index">
                  <div class="card">
                    <div class="card-body">
                      <ContentLoader />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal -->
              <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
                aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="text-end m-3">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="text-center">
                        <h3 class="title">"{{ productName }}"</h3>
                      </div>
                      <div class="p-1 pb-4">
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Strategy
                        </h6>
                        <span>{{ viewMoreData.strategy ? viewMoreData.strategy : '-' }}</span>
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Description
                        </h6>
                        <span>{{ viewMoreData.description ? viewMoreData.description : '-' }}</span>
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Robot Type
                        </h6>
                        <span>{{ viewMoreData.robotType ? viewMoreData.robotType : '-' }}</span>
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Recommended Lot Size
                        </h6>
                        <span class="badge bg-dark me-1" v-for="(lot, index) in viewMoreData.recommendedLotSize"
                          :key="index">{{
                            `${lot}%` }}
                        </span>
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Recommended Active Pair
                        </h6>
                        <span v-for="(pair, index) in viewMoreData.recommendedActivePair" :key="index">
                          {{ pair ? index === viewMoreData.recommendedActivePair.length - 1 ? `${pair}` : `${pair},` :
                            '-' }}
                        </span>
                        <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                          Recommended Pair Option
                        </h6>
                        <span class="badge bg-dark me-1" v-for="(pair, index) in viewMoreData.recommendedPairOption"
                          :key="index">
                          {{ pair }}
                        </span>
                        <div v-if="productPrice">
                          <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                            Robot Price
                          </h6>
                          Rp
                          {{
                            new Intl.NumberFormat("id-ID").format(
                              Number(parseInt(productPrice)).toFixed()
                            )
                          }}
                        </div>
                        <div v-else-if="!productPrice">
                          <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                            Robot Price
                          </h6>
                          <p class="text badge badge-danger">Gagal memuat</p>
                        </div>
                        <div v-else-if="!artKey">
                          <h6 class="fw-bold mb-0 mt-3" style="font-size: 10pt">
                            Artkey Price
                          </h6>
                          <p class="text badge badge-danger">Gagal memuat</p>
                        </div>
                      </div>
                      <!-- <div v-else>
                                                <p  class="text-justify px-3" v-html="strategy"></p>
                                            </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Fund Managers -->
          <div class="row">
            <div class="col-lg-12 connectedSortable">
              <div class="d-flex justify-content-between mt-3">
                <h5 class="title">Fund Managers</h5>
                <router-link to="/my-products/fund-manager" class="text-danger fw-bold text-decoration-none">
                  View All
                </router-link>
              </div>

              <h5 class="text-mude" v-if="fundmanager.length < 1 && !loading">
                Fund Manager Not Available.
              </h5>

              <swiper ref="fundSwiper" :options="swiperOptions" v-if="fundmanager.length > 0">
                <swiper-slide v-for="(data, index) in fundActive" :key="index">
                  <div class="card card_robot">
                    <div class="card-body">
                      <figure class="robot_img">
                        <img :src="data.image" alt="" />
                      </figure>
                      <div class="text">
                        <h6 class="name">{{ data.name }}</h6>
                        <p class="subname">{{ data.username }}</p>

                        <div class="row">
                          <div class="col-6">
                            <p class="info">Risk Level</p>
                            <p class="info_text">
                              <span class="badge badge-danger" v-if="data.risk_level == 3">HIGH</span>
                              <span class="badge badge-warning" v-else-if="data.risk_level == 2">MEDIUM</span>
                              <span class="badge badge-success" v-else>LOW</span>
                            </p>
                          </div>
                          <div class="col-12 data-strategy">
                            <p class="info">Strategy</p>
                            <div class="d-flex align-items-center justify-content-between">
                              <p class="desc" v-if="data.strategy.length >= 30"
                                v-html="data.strategy.substring(0, 30) + '...'">
                              </p>
                              <p class="desc" v-else v-html="data.strategy ? data.strategy : '-'"></p>
                              <!-- Button trigger modal -->
                              <button type="button" class="btn read_btn btn-sm" v-if="data.strategy.length >= 30"
                                @click="viewMoreF(data)" data-toggle="modal" data-target="#staticBackdrop">
                                Read More
                              </button>
                            </div>
                            <!-- <p class="desc" v-html="data.strategy ? data.strategy : '-'"></p> -->
                          </div>
                        </div>
                      </div>
                      <div class="button">
                        <router-link :to="'/fund-manager/' + data.id" class="btn btn_red btn-block">View
                          Detail</router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div> -->
              </swiper>

              <div class="row" v-if="loading">
                <div class="col-lg-4" v-for="index in 3" :key="index">
                  <div class="card">
                    <div class="card-body">
                      <ContentLoader />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="banner">
                <div class="row align-items-center">
                  <div class="col-lg-8">
                    <h1 class="banner_title">Do you want to earn extra income?</h1>
                    <p class="desc">
                      Invite friends to join in trading, by sending your referral code.
                    </p>
                    <button v-if="configure.length == 0" class="btn btn_red" @click="handleRequest">
                      Join Now
                    </button>
                    <router-link v-else-if="
                      configure[0].admission_status !== 'PENDING' &&
                      configure[0].is_active
                    " to="/introduction-broker" class="btn btn_red">Join Now</router-link>
                    <button disabled v-else class="btn btn_red">Processing</button>
                  </div>
                  <div class="col-lg-4">
                    <img src="../assets/image/invite_img.svg" class="inv_img" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="modal fade" id="maintenanceModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="text-center">
                <img src="../assets/maintenance.png" style="width: 60%" alt="" />
                <h3 class="title mt-4">
                  We'll be ready soon! This site is still under construction
                </h3>
                <!-- <p>This site is currently still maintenance!</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <dash-footer></dash-footer> -->
  </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import ContentLoader from "../components/ContentLoader.vue";

import jwt_decode from "jwt-decode";
import axios from "axios";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

import swal from "sweetalert";

import moment from "moment";
import $ from "jquery";

export default {
  name: "Dashboard",
  directives: {
    swiper: directive,
  },
  components: {
    DashHeader,
    // DashFooter,
    Sidebar,
    Swiper,
    SwiperSlide,
    ContentLoader,
  },
  data() {
    return {
      isProfileVerified: false,
      robots: [],
      lot_size: [],
      pair_option: [],
      fundmanager: [],
      subscriptions: [],
      filtersubs: [],
      pendingorder: [],
      myreferral: [],
      configure: [],
      myib: [],
      perPage: 5,
      currentPage: 1,
      strategy: "",
      productName: "",
      productPrice: 0,
      artKey: 0,
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "total_deposit",
          label: "Deposit",
          sortable: true,
        },
      ],

      viewMoreData: {
        strategy: '',
        description: '',
        robotType: '',
        recommendedLotSize: [],
        recommendedActivePair: [],
        recommendedPairOption: []
      },
      brokers: [],
      RobotName: "",
      loading: false,
      swiperOptions: {
        slidesPerView: 3.2,
        spaceBetween: 10,
        // centeredSlides: true,
        breakpoints: {
          320: {
            slidesPerView: 2.2,
            spaceBetween: 10,
            // centeredSlides: true,
          },
          640: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    robotsActive() {
      return this.robots.filter((p) => p.is_active == true);
    },
    fundActive() {
      return this.fundmanager.filter((f) => f.is_active == true);
    },
    swiper() {
      return this.$refs.robotSwiper.$swiper;
    },
    swiperF() {
      return this.$refs.fundSwiper.$swiper;
    },
    swiperS() {
      return this.$refs.subsSwiper.$swiper;
    },
    rows() {
      return this.myreferral.length;
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    $('[data-widget="treeview"]').Treeview("init");
    this.loading = true;

    var token = localStorage.getItem("access_token");
    var access_token = jwt_decode(token);
    const user_id = access_token.user_id;

    if (!localStorage.getItem("user_id")) {
      localStorage.setItem("user_id", user_id);
    }
    await axios.get(`investor/${localStorage.user_id}/ib/`).then((res) => {
      this.configure = res.data.data;
    });
    // axios.interceptors.response.use( (response) => {
    //     // Return a successful response back to the calling service
    //     return response;
    // }, (e) => {
    //     // console.log('response e', e.response)
    //     if (e.response.status == 401) {
    //         if (e.response.statusText == "Unauthorized") {

    //             $('#maintenanceModal').modal('hide')

    //             setTimeout(() => {
    //                 // Hapus token di cookie
    //                 localStorage.removeItem('access_token')
    //                 // Redirect Home atau login
    //                 this.$router.push('/login')
    //             }, 2000)
    //         }
    //     }
    //     return Promise.reject(e.response);
    // })

    try {
      let investorResponse = await axios.get(`investor/${localStorage.user_id}/`);

      if ((investorResponse?.data?.data?.identity_file ?? null) == null) {
        $("#maintenanceModal").modal("hide");
        this.$router.push("/profile/update");
        return;
      }

      if(investorResponse?.data?.data?.profile_verified_at != null){
        this.isProfileVerified = true
      }
      // if (this.$router.currentRoute.fullPath == '/dash') {
      //     $('#maintenanceModal').modal('show')
      // }

      // let referralResponse = await axios.get(`investor/?referral=${localStorage.user_id}`)
      let referralResponse = await axios.get(
        `investor/${localStorage.user_id}/referral/`
      );
      this.myreferral = referralResponse.data.data;
      // console.log('Referral data: ', this.myreferral)
      await axios
        .get(`artkey/price/`)
        .then((response) => {
          this.artKey = response.data.data.selling_price;
        })
        .catch(() => {
          // console.log('Error Robot: ', err.response)
        });
      let productResponse = await axios.get(`investor/${localStorage.user_id}/products/`);
      setTimeout(() => {
        this.loading = false;
        this.robots = productResponse.data.data.robots;
        this.fundmanager = productResponse.data.data.fund_managers;
      });

      let pendingorderResponse = await axios.get(
        `investor/${localStorage.user_id}/pendingorder/`
      );
      setTimeout(() => {
        this.loading = false;
        this.pendingorder = pendingorderResponse.data.data;
        // console.log('Pending: ', this.pendingorder)
        // var pending = pendingorderResponse.data.data
        // // console.log('Pending',this.pendingorder);
        // for (let j = 0; j < pending.length; j++) {
        //     console.log('Masuk Pending For 1 ')
        //     axios.get(`broker/`)
        //     .then(response => {
        //         var broker = response.data.data
        //         for (let k = 0; k < broker.length; k++) {
        //             if (pending[j].broker_account_id == broker[k].id) {
        //                 // console.log('Broker by id: ', broker[k].id + broker[k].name)
        //                 this.brokers.push(broker[k])
        //             }
        //         }

        //     }).catch((err) => {
        //         this.loading = false
        //         console.log('Error transactions: ', err.response)
        //     })
        // }
      });

      let subscriptionResponse = await axios.get(
        `investor/${localStorage.user_id}/subscription/`
      );
      setTimeout(() => {
        this.loading = false;
        this.subscriptions = subscriptionResponse.data.data;
        // console.log('subs: ', this.subscriptions)

        // for (let i = 0; i < this.subscriptions.length; i++) {
        //     console.log('Masuk For 1 ')
        //     axios.get(`transaction/${this.subscriptions[i].transaction_id}`)
        //     .then(response => {
        //         // console.log("Data: ", response.data.data)
        //         this.transactions = response.data.data
        //         // console.log('Trans: ', this.transactions)
        //         this.filtersubs.push(this.transactions)

        //     }).catch((err) => {
        //         this.loading = false
        //         console.log('Error transactions: ', err.response)
        //     })
        // }
      });
    } catch (e) {
      // console.log('Error Robot: ', e.response)

      // alert(e.message)
      swal("Oppss!!!", e.message, "warning", {
        button: "OK",
      });
    }
  },
  methods: {
    handleRequest() {
      this.loading = true;
      this.submitted = true;
      let data = new FormData();
      data.append("investor_id", localStorage.user_id);

      axios
        .post(`investor/ib/admission/`, data)
        .then((response) => {
          this.loading = false;
          // console.log('Resend: ', response);
          swal("Success", response.data.message, "success", {
            button: "OK",
          }).then(() => {
            window.location.reload();
          });

          axios
            .get(`investor/${localStorage.user_id}/ib/`)
            .then((result) => {
              this.configure = result.data.data;
            })
            .catch(() => {
              // console.log(err.response);
            });
        })
        .catch((err) => {
          this.loading = false;
          // console.log(err.response);
          swal("Sorry,,,,", err.response.data.message, "error", {
            button: "OK",
          });
        });
    },
    sendIdTrans(pend) {
      localStorage.setItem("transaction_id", pend.id);
    },
    handleRobot(item) {
      this.RobotName = item.product_name;
      // console.log('Send Robot: ', this.RobotName)
    },
    formatDate(value) {
      return moment(value).format("DD-MM-YYYY, h:mm:ss a");
    },
    formatPrice(val) {
      // return val.toFixed(2);
      return new Intl.NumberFormat("id-ID", {
        currencySign: "accounting",
        maximumSignificantDigits: 2,
      }).format(val);
    },
    viewMore(robot) {
      let strategy = robot.strategy.split(";");
      let firstElement = strategy[0];
      let firstElementWithoutPTag = firstElement.replace(/<p[^>]*>(.*?)<\/p>/g, '$1');

      // this.strategy = robot.strategy.split(";");
      // this.lot_size = this.strategy[3]?.split(",");
      // this.pair_option = this.strategy[5]?.split(",");
      // this.productName = robot.name;
      // this.productPrice = robot?.selling_price;

      this.viewMoreData.strategy = firstElementWithoutPTag;
      this.viewMoreData.description = robot.description;
      this.viewMoreData.robotType = robot.robot_type;
      this.viewMoreData.recommendedLotSize = robot.lot_sizes.map((data) => data.lot);
      this.viewMoreData.recommendedActivePair = robot.active_pairs.map(
        (data) => data.active_pair
      );
      this.viewMoreData.recommendedPairOption = robot.pair_options.map(
        (data) => data.symbol
      );
      console.log(this.viewMoreData);
    },
    viewMoreF(data) {
      this.strategy = data.strategy.split(";");
      this.lot_size = this.strategy[3]?.split(",");
      this.pair_option = this.strategy[5]?.split(",");
      this.productName = data.name;
      this.productPrice = data?.selling_price;
    },
  },
};
</script>

<style>
.data-strategy {
  min-height: 145px !important;
}

.item_title.prices {
  display: flex;
  align-items: center;
}

.item_title.prices .text {
  width: 200px;
}

.wa {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
}

.content-header h1 {
  font-weight: 700;
  color: var(--dark-grey);
}

.content-header .breadcrumb-item a {
  color: var(--grey);
  text-decoration: none;
}

.content-header .breadcrumb-item.active {
  color: var(--red);
}

.content.dash .type_text {
  font-size: 10pt !important;
}

.content.dash .swiper-container {
  overflow-x: scroll;
}

.content.dash .swiper-container::-webkit-scrollbar {
  height: 6px;
}

.content.dash .swiper-container::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 2px grey;  */
  background: #e9e9e9;
  border-radius: 5px;
}

.content.dash .swiper-container::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 5px;
}

.content.dash .swiper-container::-webkit-scrollbar-thumb:hover {
  background: #797979;
}

.content {
  overflow-x: hidden;
  width: 100%;
}

.content .card {
  background: white !important;
  border-radius: 10px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.06);
  border: 0;
}

.content .card .card-header {
  background: transparent;
  border: 0;
  padding: 16px;
}

.content .card .card-header .card-title {
  color: var(--dark-grey);
  font-weight: 600;
  margin: 0;
}

.content .card_friends table.table thead tr th {
  color: var(--grey);
}

.content .card_friends table.table tbody tr td .name_col {
  height: 100% !important;
  margin: 5px 0 -10px;
}

.content .card_friends table.table tbody tr,
.content .card_friends table.table tbody tr td {
  border: 0 !important;
}

.content .card_friends table.table tbody tr td .friends_img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.content .card_friends .table tbody tr td .friends_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.content h5.title {
  font-weight: 700;
  color: var(--dark-grey);
  font-size: 18pt;
}

.content .card_robot .robot_img {
  width: 100%;
  height: 160px;
  margin: 0 10px 0 0;
}

.content .card_robot .robot_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.content .card_robot .text .name {
  font-weight: 700;
  color: var(--dark-grey);
  margin: 20px 0 10px;
  font-size: 14pt;
}

.content .card_robot .text .subname {
  font-size: 8pt;
  color: var(--grey);
}

.content .card_robot .text .info {
  font-size: 8pt;
  color: var(--dark-grey);
  margin: 0;
}

.content .card_robot .text .info_text {
  font-size: 12pt;
}

.content .card_robot .text .desc {
  font-size: 8pt;
  color: var(--dark-grey);
}

.content .btn_red {
  padding: 10px !important;
}

.content .banner {
  margin: 20px 0;
  padding: 20px;
  background: var(--bg-black);
  border-radius: 14px;
}

.content .banner .banner_title {
  font-weight: 700;
  font-size: 24pt;
  color: var(--dark-grey);
}

.content .banner .desc {
  font-weight: 400;
  font-size: 12pt;
  color: var(--dark-grey);
}

.content .banner .inv_img {
  width: 100%;
  height: auto;
  margin: -20px 0;
}

@media (max-width: 575.98px) {
  .content .card_robot .text .name {
    font-weight: 700;
    color: var(--dark-grey);
    margin: 20px 0 10px;
    font-size: 12pt;
  }

  .content .card_robot .text .subname {
    font-size: 8pt;
    color: var(--grey);
  }

  .content .card_robot .text .info {
    font-size: 8pt;
    color: var(--dark-grey);
    margin: 0;
  }

  .content .card_robot .text .info_text {
    font-size: 10pt;
  }

  .content .card_robot .text .desc {
    font-size: 8pt;
    color: var(--dark-grey);
  }

  .content .card .button .btn {
    padding: 8px !important;
    font-size: 8pt !important;
  }

  .content .card .read_btn {
    font-size: 8pt !important;
  }

  .content .card_robot .robot_img {
    width: 100%;
    height: 120px;
    margin: 0 10px 0 0;
  }

  .content .card_robot .text .price {
    font-size: 12pt;
    font-weight: 700;
  }
}
</style>
